'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _dec, _class, _class2, _temp2;

var _reactRedux = require('react-redux');

var _translate_pipo = require('redux/actions/translate_pipo');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
    TranslatePipo: {
        displayName: 'TranslatePipo'
    }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
    filename: '/usr/local/ibonus/src/components/TranslatePipo/index.jsx',
    components: _components,
    locals: [],
    imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
    return function (Component) {
        return _reactTransformCatchErrors2(Component, id);
    };
}

var TranslatePipo = _wrapComponent('TranslatePipo')((_dec = (0, _reactRedux.connect)(function (state) {
    return {
        langList: state.translate_pipo.list,
        currency: state.currency
    };
}, { getLang: _translate_pipo.getLang }), _dec(_class = (_temp2 = _class2 = function (_Component) {
    (0, _inherits3.default)(TranslatePipo, _Component);

    function TranslatePipo() {
        var _ref;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, TranslatePipo);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = TranslatePipo.__proto__ || (0, _getPrototypeOf2.default)(TranslatePipo)).call.apply(_ref, [this].concat(args))), _this), _this.renderLang = function () {
            var _this$props = _this.props,
                title = _this$props.title,
                langList = _this$props.langList;


            if (langList.hasOwnProperty(title)) {
                var strOut = langList[title];

                if (_this.props.additionalValues) {
                    _this.props.additionalValues.forEach(function (item, i) {
                        var re = new RegExp('\\{' + i + '\\}', 'g');
                        var putItem = langList.hasOwnProperty(item) ? langList[item] : item;
                        strOut = strOut.replace(re, putItem);
                    });
                }

                return strOut;
            }

            if (_this.props['default']) {
                return _this.props['default'];
            }

            return title;
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    (0, _createClass3.default)(TranslatePipo, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            if (!this.props.langList.hasOwnProperty(this.props.title)) {
                this.props.getLang(this.props.currency.lang.slug);
            }
        }
    }, {
        key: 'render',
        value: function render() {

            if (this.props.raw) {
                return _react3.default.createElement('span', { dangerouslySetInnerHTML: { __html: this.renderLang() } });
            }

            return _react3.default.createElement(
                'span',
                null,
                this.renderLang()
            );
        }
    }]);
    return TranslatePipo;
}(_react2.Component), _class2.propTypes = {
    title: _react2.PropTypes.string.isRequired,
    default: _react2.PropTypes.string,
    getLang: _react2.PropTypes.func,
    langList: _react2.PropTypes.object,
    raw: _react2.PropTypes.bool, //с html  тегами
    additionalValues: _react2.PropTypes.array, //для вставки в {0} {1}
    currency: _react2.PropTypes.object.isRequired
}, _class2.defaultProps = {
    raw: false
}, _temp2)) || _class));

exports.default = TranslatePipo;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/TranslatePipo/index.jsx
// module id = 1775
// module chunks = 0